<div class="sticky-toolbar mb-8 text-[14px]">
    <p-toolbar class="text-[14px] p-0">
    <ng-template #start>
        <!-- Print/PDF actions work only for legacy HTML invoices (not for M3 iframe mode). -->
        <button
            *ngIf="!invoiceDataLoaded"
            pButton
            type="button"
            icon="pi pi-print"
            [label]="isPreviewMode ? 'Print Preview' : 'Print'"
            class="p-button-sm p-button-secondary"
            (click)="printInvoice()"
        ></button>

        <button
            *ngIf="!invoiceDataLoaded"
            pButton
            type="button"
            icon="pi pi-file-pdf"
            label="Export PDF"
            class="p-button-sm p-button-secondary ml-2"
            (click)="exportToPDF()"
        ></button>

        <!-- Existing preview actions were previously commented out; keep them disabled for now. -->
    </ng-template>
    <ng-template #end>
        <button pButton type="button" icon="pi pi-arrow-left" label="Back" class="p-button-sm p-button-secondary ml-2" (click)="goBack()"></button>
    </ng-template>
</p-toolbar>
</div>

<p-toast />
<p-confirmDialog />
<p-dialog header="Already Synced"
          [(visible)]="alreadySyncedDialogVisible"
          [modal]="true"
          [dismissableMask]="false"
          [style]="{ width: '400px'}"
          contentStyle="padding:0; display:flex; align-items:center; gap:12px; overflow:visible;">
    <ng-template pTemplate="content">
        <div style="display:flex; align-items:center; gap:12px; width:100%;">
            <i class="pi pi-info-circle" style="font-size:1.8rem; flex:0 0 auto;"></i>
            <div style="font-size:16px; padding-right:8px; flex:1 1 auto; word-break:break-word;">
                {{ alreadySyncedDialogMessage }}
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <p-button label="OK" icon="pi pi-check" styleClass="p-button-sm" (click)="alreadySyncedDialogVisible = false"></p-button>
    </ng-template>
</p-dialog>

<p-dialog header="Customer blocked"
          [(visible)]="customerBlockedDialogVisible"
          [modal]="true"
          [dismissableMask]="false"
          [style]="{ width: '400px'}"
          contentStyle="padding:0; display:flex; align-items:center; gap:12px; overflow:visible;">
    <ng-template pTemplate="content">
        <div style="display:flex; align-items:center; gap:12px; width:100%;">
            <i class="pi pi-ban" style="font-size:1.8rem; flex:0 0 auto; color:#c62828;"></i>
            <div style="font-size:16px; padding-right:8px; flex:1 1 auto; word-break:break-word;">
                {{ customerBlockedDialogMessage }}
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <p-button label="OK" icon="pi pi-check" styleClass="p-button-sm" (click)="customerBlockedDialogVisible = false"></p-button>
    </ng-template>
</p-dialog>

<p-dialog [(visible)]="invoiceInProgressDialogVisible"
          [modal]="true"
          [closable]="true"
          [dismissableMask]="true"
          [style]="{ width: '480px' }"
          styleClass="invoice-in-progress-dialog"
          (onHide)="closeInvoiceInProgressDialog()">
    <ng-template pTemplate="header">
        <div class="flex align-items-center gap-3">
            <span class="invoice-in-progress-icon"><i class="pi pi-clock"></i></span>
            <span class="text-xl font-semibold">Invoice Is Being Generated</span>
        </div>
    </ng-template>
    <ng-template pTemplate="content">
        <div class="invoice-in-progress-content">
            <ng-container *ngIf="!invoiceInProgressFinalMessage; else invoiceInProgressFinal">
                <p class="mb-3">
                    Your invoice is still being generated in the system. This usually takes up to one minute after the order is synced.
                </p>
                <p class="mb-3 text-color-secondary">
                    We are checking automatically every 15 seconds. You can wait here or come back later from the order screen.
                </p>
                <div class="invoice-in-progress-status flex align-items-center justify-content-between gap-2">
                    <span>Next check in <strong>{{ invoiceInProgressCountdown }}</strong> seconds</span>
                    <span class="invoice-in-progress-badge">Attempt {{ invoiceInProgressAttempt }} of 5</span>
                </div>
            </ng-container>
            <ng-template #invoiceInProgressFinal>
                <p class="mb-3">
                    We could not retrieve the invoice PDF automatically.
                </p>
                <p class="mb-3 text-color-secondary">
                    {{ invoiceInProgressFinalMessage }}
                </p>
            </ng-template>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <ng-container *ngIf="!invoiceInProgressFinalMessage; else invoiceInProgressFinalFooter">
            <p-button label="Refresh now" icon="pi pi-refresh" styleClass="p-button-primary" (click)="retryInvoiceFetch()"></p-button>
            <p-button label="Go back" icon="pi pi-arrow-left" styleClass="p-button-outlined p-button-secondary" (click)="closeInvoiceInProgressAndGoBack()"></p-button>
        </ng-container>
        <ng-template #invoiceInProgressFinalFooter>
            <p-button label="Go back" icon="pi pi-arrow-left" styleClass="p-button-outlined p-button-secondary" (click)="closeInvoiceInProgressAndGoBack()"></p-button>
        </ng-template>
    </ng-template>
</p-dialog>

<div #invoice class="invoice-scroll-root">

<!-- Display base64 PDF in iframe -->
<div *ngIf="invoiceDataLoaded && invoiceBase64Data" class="invoice-container" style="width: 100%; margin: 24px auto;">
<iframe 
    [src]="invoicePdfUrl" 
    style="width: 100%; height: 900px; border: 1px solid #ddd; border-radius: 6px;">
</iframe>
</div>

<!-- Fallback: Show original template if no base64 data yet -->
<div *ngIf="!invoiceDataLoaded" #invoice>
<div class="invoice-wrapper print-page" 
     [class.preview-mode]="isPreviewMode"
     *ngFor="let pageLines of paginatedContent; let i = index"
     >
    <!-- Header -->
      <!-- Header -->
        <div #header class="header-top avoid-break">
            <img [src]="headerImage" class="logo" />
          </div>

    <!-- Main Content -->
    <div class="main-content avoid-break">
        <!-- Preview watermark only on this table area; watermark-footer below stays unchanged -->
        <div class="preview-table-area" [class.preview-page]="isPreviewMode">
        <div #mainContent class="address-invoice-row">
            <div class="address-block">
                <div>{{ item?.customerName }}</div>
                <div *ngFor="let line of getAddressLines(customerDetails.CUA1)">
                    {{ line }}
                </div>
                <div *ngFor="let phone of getPhoneLines(customerDetails.phoneNumber)">
    {{ phone }}
</div>
            </div>
            <div class="invoice-block">
                <div class="invoice-title">
                    <b>{{ getLabel('invoiceTitle') }}</b>
                </div>
                <table>
                    <tr>
                        <td>{{ getLabel('invoiceNo') }}</td>
                        <td>:</td>
                        <td>{{ isPreviewMode ? (getLabel('preview') || 'Preview') : (invoiceDetails.invoiceNo || '') }}</td>
                    </tr>
                    <tr>
                        <td>{{ getLabel('customerNo') }}</td>
                        <td>:</td>
                        <td>{{ invoiceDetails.customerNo }}</td>
                    </tr>
                    <tr>
                        <td>{{ getLabel('date') }}</td>
                        <td>:</td>
                        <td>{{ invoiceDetails.date }}</td>
                    </tr>
                    <tr>
                        <td>{{ getLabel('orderNumber') }}</td>
                        <td>:</td>
                        <td>{{ invoiceDetails.orderNumber }}</td>
                    </tr>
                    <tr>
                        <td>{{ getLabel('referenceOrderNumber') }}</td>
                        <td>:</td>
                        <td>{{ isPreviewMode ? (getLabel('preview') || 'Preview') : (invoiceDetails.referenceOrderNumber || '') }}</td>
                    </tr>
                </table>
            </div>
        </div>

        <table #itemsTable class="items-table" >
            <thead>
                <tr>
                    <th>{{ getLabel('position') }}</th>
                    <th [innerHTML]="getLabel('itemNo')"></th>
                    <th>{{ getLabel('quantity') }}</th>
                    <th>{{ getLabel('description') }}</th>
                    <th>{{ getLabel('size') }}</th>
                    <th>{{ getLabel('pcs') }}</th>
                    <th>{{ getLabel('price') }}</th>
                    <th>{{ getLabel('discount') }}</th>
                    <th>{{ getLabel('amount') }}</th>
                    <th>{{ getLabel('vatCode') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let line of pageLines">
                    <td>{{ line.position }}</td>
                    <td>{{ line.itemNo }}</td>
                    <td>{{ line.quantity }}</td>
                    <td>{{ line.description }}</td>
                    <td class="size-cell">{{ line.size }}</td>
                    <td>{{ line.pcs }}</td>
                    <td>{{ line.ppuEUR | number: '1.2-2' }}</td>
                    <td>{{ line.discountPercent | number: '1.2-2' }}</td>
                    <td>{{ line.lineAmount | number: '1.2-2' }}</td>
                    <td>{{ line.vatCode }}</td>
                </tr>
            </tbody>
        </table>

        <!-- Summary inside last page if !summaryOnExtraPage -->
        <ng-container *ngIf="i === paginatedContent.length - 1 && !summaryOnExtraPage">
            <div #summaryDiv class="Summary avoid-break" style="width: 100%;">
<div style="display: flex; width: 100%; align-items: flex-start;">
    <!-- Ident Numbers & Notice Block (left side) -->
    <div class="ident-numbers-table-wrapper" style="min-width: 260px;">
        <table class="ident-numbers-table">
            <tbody>
                <tr>
                    <td>{{ getLabel('supplierIdentNo') }}</td>
                    <td>{{ supplierDetails.supplerVrno }}</td>
                </tr>
                <tr>
                    <td>{{ getLabel('customerIdentNo') }}</td>
                    <td>{{ customerDetails.customerVrno }}</td>
                </tr>
                <tr>
                    <td>{{ getLabel('grossWeight') }}</td>
                    <td>{{ summary.totalGrossWeight | number: '1.2-2' }}</td>
                </tr>
            </tbody>
        </table>
        <div class="atradius-notice-row" *ngIf="div1 === '400'">
            <div class="atradius-notice-box">
                <div>Wij zijn verplicht<br>
                achterstallige posten<br>
                ter incasso aan<br>
                Alliance over te dragen
                </div>
                <div class="atradius-logo">Alliance</div>
            </div>
            <div class="atradius-notice-box">
                <div>We are obliged<br>
                to refer overdue<br>
                invoices to Alliance<br>
                for collection
                </div>
                <div class="atradius-logo">Alliance</div>
            </div>
        </div>
    </div>
    <!-- Summary Block (right side) -->
    <div class="invoice-summary-table-wrapper" style="margin-left: auto; max-width: 340px;">
        <table class="invoice-summary-table" style="border-collapse: collapse; width: 100%;">
            <tbody>
                <tr>
                    <td style="text-align: right; font-weight: bold;">{{ getLabel('grossValue') }}:</td>
                    <td style="text-align: right;">{{ summary.grossValue | number: '1.2-2' }}</td>
                </tr>
                <tr>
                    <td style="text-align: right; font-weight: bold;">{{ getLabel('totalDiscountValue') }}:</td>
                    <td style="text-align: right;">{{ summary.totalDiscountValue | number: '1.2-2' }}</td>
                </tr>
                <tr>
                    <td style="text-align: right; font-weight: bold;">{{ getLabel('netAmount') }}:</td>
                    <td style="text-align: right;">{{ summary.netAmount | number: '1.2-2' }}</td>
                </tr>
                <tr>
                    <td style="vertical-align: top; padding-top: 10px;" colspan="2">
                        <table style="border-collapse: collapse; font-size: 10px; width: 100%;">
                            <thead>
                                <tr>
                                    <th style="text-align: left">{{ getLabel('vatPercentLabel') }}</th>
                                    <th style="text-align: left">{{ getLabel('taxBaseLabel') }}</th>
                                    <th style="text-align: left">{{ getLabel('vatAmountLabel') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let vat of summary.vatSummaries">
                                    <td>{{ vat.vatPercentage | number: '1.2-2' }}</td>
                                    <td>{{ vat.totalNetAmount | number: '1.2-2' }}</td>
                                    <td>{{ vat.totalVatAmount | number: '1.2-2' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td style="text-align: right; font-weight: bold;">{{ getLabel('orderValue') }}:</td>
                    <td style="text-align: right;"><strong>{{ summary.totalOrderValue | number: '1.2-2' }}</strong></td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
</div>
        </ng-container>
        </div>
        <!-- watermark-footer unchanged: no preview styling -->
        <div class="watermark-footer">
            <img src="assets/torna_logo.png" alt="Watermark" />
        </div>
    </div>

    <!-- Footer on every page -->
       <div #footer class="footer avoid-break">
            <img [src]="footerImage" class="footer-logo" />
          </div>
</div>
<!-- Summary on extra page if needed -->
<div *ngIf="summaryOnExtraPage">
    <div class="invoice-wrapper print-page" 
         [class.preview-mode]="isPreviewMode"
         style="display: flex; flex-direction: column; min-height: 297mm;">
    <!-- Header -->
     <!-- Header -->
        <div #header class="header-top avoid-break">
            <img [src]="headerImage" class="logo" />
          </div>
    <!-- Main Content -->
    <div class="main-content avoid-break" style="flex: 1 0 auto;">
        <div class="preview-table-area preview-table-area--extra" [class.preview-page]="isPreviewMode">
        <div class="Summary avoid-break" style="width: 100%;">
            <div style="display: flex; width: 100%; align-items: flex-start;">
                <!-- Ident Numbers & Notice Block (left side) -->
                <div class="ident-numbers-table-wrapper" style="min-width: 260px;">
                    <table class="ident-numbers-table">
                        <tbody>
                            <tr>
                                <td>{{ getLabel('supplierIdentNo') }}</td>
                                <td>{{ supplierDetails.supplerVrno }}</td>
                            </tr>
                            <tr>
                                <td>{{ getLabel('customerIdentNo') }}</td>
                                <td>{{ customerDetails.customerVrno }}</td>
                            </tr>
                            <tr>
                                <td>{{ getLabel('grossWeight') }}</td>
                                <td>{{ summary.totalGrossWeight | number: '1.2-2' }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="atradius-notice-row" *ngIf="div1 === '400'">
                        <div class="atradius-notice-box">
                            <div>Wij zijn verplicht<br>
                            achterstallige posten<br>
                            ter incasso aan<br>
                            Alliance over te dragen
                            </div>
                            <div class="atradius-logo">Alliance</div>
                        </div>
                        <div class="atradius-notice-box">
                            <div>We are obliged<br>
                            to refer overdue<br>
                            invoices to Alliance<br>
                            for collection
                            </div>
                            <div class="atradius-logo">Alliance</div>
                        </div>
                    </div>
                </div>
                <!-- Summary Block (right side) -->
                <div class="invoice-summary-table-wrapper" style="margin-left: auto; max-width: 340px;">
                    <table class="invoice-summary-table" style="border-collapse: collapse; width: 100%;">
                        <tbody>
                            <tr>
                                <td style="text-align: right; font-weight: bold;">{{ getLabel('grossValue') }}:</td>
                                <td style="text-align: right;">{{ summary.grossValue | number: '1.2-2' }}</td>
                            </tr>
                            <tr>
                                <td style="text-align: right; font-weight: bold;">{{ getLabel('totalDiscountValue') }}:</td>
                                <td style="text-align: right;">{{ summary.totalDiscountValue | number: '1.2-2' }}</td>
                            </tr>
                            <tr>
                                <td style="text-align: right; font-weight: bold;">{{ getLabel('netAmount') }}:</td>
                                <td style="text-align: right;">{{ summary.netAmount | number: '1.2-2' }}</td>
                            </tr>
                            <tr>
                                <td style="vertical-align: top; padding-top: 10px;" colspan="2">
                                    <table style="border-collapse: collapse; font-size: 10px; width: 100%;">
                                        <thead>
                                            <tr>
                                                <th style="text-align: left">{{ getLabel('vatPercentLabel') }}</th>
                                                <th style="text-align: left">{{ getLabel('taxBaseLabel') }}</th>
                                                <th style="text-align: left">{{ getLabel('vatAmountLabel') }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let vat of summary.vatSummaries">
                                                <td>{{ vat.vatPercentage | number: '1.2-2' }}</td>
                                                <td>{{ vat.totalNetAmount | number: '1.2-2' }}</td>
                                                <td>{{ vat.totalVatAmount | number: '1.2-2' }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td style="text-align: right; font-weight: bold;">{{ getLabel('orderValue') }}:</td>
                                <td style="text-align: right;"><strong>{{ summary.totalOrderValue | number: '1.2-2' }}</strong></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        </div>
        <div class="watermark-footer">
            <img src="assets/torna_logo.png" alt="Watermark" />
        </div>
    </div>
    <!-- Footer OUTSIDE main-content, always at the bottom -->
        <div #footer class="footer avoid-break">
            <img [src]="footerImage" class="footer-logo" />
          </div>
</div>
</div>
